import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable()
export class LayoutContextService {
  public hideFooter$ = new BehaviorSubject<boolean>(null);
  public hideHeader$ = new BehaviorSubject<boolean>(null);
  public hideUpsSection$ = new BehaviorSubject<boolean>(true);

  public scrollOnTopOnPageChange = true;
}
